import { useMemo } from 'react';
import { useAutomationsSelector } from 'pages/AutomationEngine/store/react';
import {
  getAutomation,
  getAutomationCustomObjectFields,
} from 'pages/AutomationEngine/store/selectors';
import { Relation, RelatedField } from 'pages/AutomationEngine/types';
import { useSelector } from 'react-redux';
import { getBusinessClientObject } from 'store/authentication/selectors';

export const useObjectToModifyOptions = () => {
  const automation = useAutomationsSelector(getAutomation);
  const automationContextFields = useAutomationsSelector(
    getAutomationCustomObjectFields
  );
  const clientObject = useSelector(getBusinessClientObject);

  const { automationRelatedFields, objectToModifyOptions } = useMemo(() => {
    if (automation?.customObject && automationContextFields) {
      const seen: Record<string, boolean> = {};
      const automationRelatedFields = automationContextFields.filter(
        (f: any) => f?.relation?.relatedObject === clientObject.id
      );

      const objectToModifyOptions = automationRelatedFields
        .filter((f: RelatedField) => {
          const { relatedObject } = f.relation;
          return Object.prototype.hasOwnProperty.call(seen, relatedObject)
            ? false
            : (seen[relatedObject] = true);
        })
        .reduce((acc: any[], f: RelatedField) => {
          const fieldsToDisplay = automationRelatedFields
            .filter(
              ({ relation }: { relation: Relation }) =>
                relation.relatedObject === f.relation.relatedObject
            )
            .map((f: RelatedField) => ({
              value: f.id, // what should this be
              label: f.displayName,
              relation: f.relation,
            }));

          return fieldsToDisplay.length
            ? [
                ...acc,
                {
                  key: f.relation.relatedObject,
                  label: f.relation.relatedObjectName,
                  entityName: f.relation.relatedEntityName,
                  relation: f.relation,
                  options: fieldsToDisplay,
                },
              ]
            : acc;
        }, [])
        .sort((a: any, b: any) => {
          return a.label.localeCompare(b.label, 'en', {
            sensitivity: 'base',
          });
        });

      return { automationRelatedFields, objectToModifyOptions };
    }

    return { automationRelatedFields: [], objectToModifyOptions: [] };
  }, [automation, automationContextFields, clientObject.id]);

  return { automationRelatedFields, objectToModifyOptions };
};
